import { XTR_CURRENCY } from "../../Shop/CashRegisters/constants";

export enum Shop {
  Local = 'local',
  Global = 'global',
  Crypto = 'crypto',
  Llc = 'llc',
  Bonus = 'bonus',
}

export type GlobalSubType = typeof XTR_CURRENCY

export type Getaway = {
  name: string
  code: string
  description: string
  group: string
  weight: number
  price: string
  base_price: string
  discount_base_price: string
  currency_code: number
  currency_short_name: string
  currency_symbol: string
  currency_name: string
  required?: Record<string, any>
}

export type ShortTariffInfo = Pick<Tariff, 'name' | 'price' | 'base_price' | 'currency_symbol' | 'monthCount'>
export type ShortTariffInfoWithTotal = ShortTariffInfo & { total: number }
export type PayInfos = {
  sale: string
  tariffs: Array<ShortTariffInfoWithTotal>
}

export type Tariff = {
  name: string
  type: string
  // descriptions: []
  monthCount: number
  price: string
  base_price: string
  currency_code: number
  currency_short_name: string
  currency_symbol: string
  currency_name: string
  shops: Partial<{
    [Shop.Global]: Array<Getaway>
    [Shop.Local]: Array<Getaway>
    [Shop.Crypto]: Array<Getaway>
    [Shop.Llc]: Array<Getaway>
    [Shop.Bonus]: Array<Getaway>
  }>
}

export type Payment = {
  tariff: Tariff
  getaway: Getaway
  requiredFields: Record<string, any> | null
  coupon?: string | null
}

export type SelectedShop = {
  group: Shop | string,
} & Partial<Pick<Getaway, 'currency_short_name'>>

export type PaymentMethods = {
  tariffs: Array<Tariff>
  country: string
  promocode_success?: string
}
